import { FC } from 'react';

import { ExternalLink } from 'lucide-react';

type Props = {
    href: string;
};

export const TrackingLinkButton: FC<Props> = ({ href }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 rounded-xl bg-blue-600 px-3 py-1 text-xs font-medium text-white transition-colors hover:bg-blue-700"
    >
        <ExternalLink className="h-3 w-3" />
        Відкрити трекінг
    </a>
);
